import { render, staticRenderFns } from "./SectionEditor.vue?vue&type=template&id=24714cf2&scoped=true&"
import script from "./SectionEditor.vue?vue&type=script&lang=js&"
export * from "./SectionEditor.vue?vue&type=script&lang=js&"
import style0 from "./SectionEditor.vue?vue&type=style&index=0&id=24714cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24714cf2",
  null
  
)

export default component.exports